<script>
const rules = {
  biller: [
    { required: true, message: "Biller must not empty", trigger: 'blur' }
  ],
  amount: [
    { required: true, message: "Amount must not empty", trigger: 'blur' }
  ],
  note: [
    { required: true, message: "Note must not empty", trigger: 'blur' }
  ]
}

export default {
  props: {
    bank: {
      type: Object,
      required: true
    },
    biller: {
      type: Object,
      default: () => ({
        name: null,
        contact_name: null,
        balance: 0
      })
    }
  },
  computed: {
    projectedBankBalance() {
      const { amount } = this.form
      return parseInt(this.bank.balance) - parseInt(amount ?? 0)
    },
    projectedBillerBalance() {
      const { amount } = this.form
      return parseInt(this.biller.balance) + parseInt(amount ?? 0)
    }
  },
  data: () => ({
    rules,
    labelCol: { span: 4 },
    wrapperCol: { span: 16 },
    loading: false,
    form: {
      bank: null,
      biller: null,
      amount: null,
      note: null
    }
  }),
  created() {
    this.form.bank = this.bank.hash
  },
  methods: {
    autocomplete(v) {
      if (v.length > 0) {
        Object.assign(this.biller, v[0])
        this.form.biller = v[0].hash
      }
    },
    handleSuccess() {
      this.$emit('close')
      this.$notification.success({
        message: "Saved!",
        description: "Balance settlement successfully saved!",
        onClose: () => window.location.reload()
      })
    },
    submit() {
      this.$http.post(this.routeUri('hyperion.finances.service.settlement'), this.form)
        .then((r) => this.handleSuccess())
        .catch((e) => this.handleXhrError(e))
    }
  }
}
</script>
<template>
  <a-card type="inner" size="small" :bordered="false">
    <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules">
      <a-divider dashed orientation="left">Settlement Information</a-divider>
      <a-form-model-item label="Bank">
        <strong><a-icon type="bank" /> [{{ bank.bank_code }}] {{ bank.bank_name }}</strong>
      </a-form-model-item>

      <a-form-model-item label="Account">
        <strong><a-icon type="user" /> {{ bank.account_holder }}</strong>
      </a-form-model-item>

      <a-form-model-item label="Bank Balance">
        <a-row type="flex" justify="space-between">
          <div><strong><a-icon type="dollar" /> <currency :amount="bank.balance" /></strong></div>
          <div><small>projected balance:</small> <currency :amount="projectedBankBalance" /></div>
        </a-row>
      </a-form-model-item>

      <a-form-model-item label="Amount" :wrapper-col="{ span: 10 }" prop="amount">
        <a-input @change="(e) => form.amount = filterNumeric(e)">
          <a-icon slot="prefix" type="dollar" />
        </a-input>
      </a-form-model-item>

      <a-form-model-item label="Biller" prop="biller">
        <biller-autocomplete @change="autocomplete"/>
      </a-form-model-item>

      <a-form-model-item label="Biller Name">
        <strong><a-icon type="code" /> [{{ biller.name }}] {{ biller.contact_name }}</strong>
      </a-form-model-item>

      <a-form-model-item label="Biller Balance">
        <a-row type="flex" justify="space-between">
          <div><strong><a-icon type="dollar" /> <currency :amount="biller.balance" /></strong></div>
          <div><small>projected balance:</small> <currency :amount="projectedBillerBalance" /></div>
        </a-row>
      </a-form-model-item>

      <a-form-model-item label="Note" prop="note">
        <a-textarea placeholder="Note" :rows="4" v-model="form.note" />
      </a-form-model-item>

      <a-form-model-item :wrapperCol="{ span: this.wrapperCol.span, offset: this.labelCol.span }">
        <a-button :loading="loading" type="primary" @click="submit" icon="save">Save</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>
